export default __webpack_public_path__ + "f8e9f2fcbded9eae5dc9081b88de8690.png";